import { render, staticRenderFns } from "./ProcurementRequestForMaterialsShow.vue?vue&type=template&id=c97bf8b0&"
import script from "./ProcurementRequestForMaterialsShow.vue?vue&type=script&lang=js&"
export * from "./ProcurementRequestForMaterialsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports